import React from 'react';
import {
  Box,
  VStack,
  HStack,
  Text,
  Badge,
  Button,
  Icon,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  FileText,
  Edit,
  Eye,
  MoreVertical,
  Send,
  Clock,
  CheckCircle,
  AlertTriangle,
} from 'lucide-react';

const ContentPanel: React.FC = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  const contentItems = [
    {
      id: 'CONTENT-001',
      title: 'Stress Management Best Practices',
      type: 'Article',
      status: 'published',
      author: 'Dr. Emily Chen',
      sourceIdea: 'IDEA-001',
      publishDate: '2d ago',
      views: 342,
    },
    {
      id: 'CONTENT-002',
      title: 'Wellness Check-in Guide',
      type: 'Guide',
      status: 'review',
      author: 'Dr. James Wilson',
      sourceIdea: 'IDEA-002',
      publishDate: 'Draft',
      views: 0,
    },
    {
      id: 'CONTENT-003',
      title: 'Clinical Decision Support Tips',
      type: 'Tutorial',
      status: 'draft',
      author: 'Dr. Sarah Martinez',
      sourceIdea: 'IDEA-003',
      publishDate: 'Draft',
      views: 0,
    },
  ];

  return (
    <Box
      bg={bgColor}
      borderRadius="lg"
      boxShadow="sm"
      border="1px"
      borderColor={borderColor}
      overflow="hidden"
    >
      <Box p={6} borderBottom="1px" borderColor={borderColor}>
        <HStack justify="space-between">
          <HStack spacing={4}>
            <Icon as={FileText} boxSize={5} color="purple.500" />
            <Text fontSize="lg" fontWeight="medium">
              SentientIQ Content
            </Text>
          </HStack>
          <Button
            leftIcon={<Edit size={16} />}
            colorScheme="purple"
            size="sm"
          >
            New Content
          </Button>
        </HStack>
      </Box>

      <Table>
        <Thead>
          <Tr>
            <Th>Title</Th>
            <Th>Type</Th>
            <Th>Status</Th>
            <Th>Author</Th>
            <Th>Source Idea</Th>
            <Th>Published</Th>
            <Th>Views</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {contentItems.map((item) => (
            <Tr key={item.id}>
              <Td>
                <HStack>
                  <FileText size={16} />
                  <Text>{item.title}</Text>
                </HStack>
              </Td>
              <Td>
                <Badge colorScheme="blue" fontSize="xs">
                  {item.type}
                </Badge>
              </Td>
              <Td>
                <Badge
                  colorScheme={
                    item.status === 'published'
                      ? 'green'
                      : item.status === 'review'
                      ? 'orange'
                      : 'gray'
                  }
                  fontSize="xs"
                >
                  {item.status}
                </Badge>
              </Td>
              <Td>{item.author}</Td>
              <Td>
                <Badge colorScheme="purple" fontSize="xs">
                  {item.sourceIdea}
                </Badge>
              </Td>
              <Td>
                <Text color="gray.500" fontSize="sm">
                  {item.publishDate}
                </Text>
              </Td>
              <Td>{item.views}</Td>
              <Td>
                <Menu>
                  <MenuButton
                    as={IconButton}
                    icon={<MoreVertical size={16} />}
                    variant="ghost"
                    size="sm"
                  />
                  <MenuList>
                    <MenuItem icon={<Eye size={16} />}>Preview</MenuItem>
                    <MenuItem icon={<Edit size={16} />}>Edit</MenuItem>
                    <MenuItem icon={<Send size={16} />}>Publish</MenuItem>
                  </MenuList>
                </Menu>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default ContentPanel;
